import { PriceService } from "./utils/priceService";

export const priceService = new PriceService();
